"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Search;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Search(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "search"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "outline-4",
    "data-name": "outline",
    d: "M81.246,18.754A38.365,38.365,0,0,0,25.28,71.185L8.216,88.248a2.5,2.5,0,1,0,3.535,3.535L28.815,74.72A38.365,38.365,0,0,0,81.246,18.754ZM77.71,69.481a33.354,33.354,0,1,1,0-47.191A33.151,33.151,0,0,1,77.71,69.481Z"
  }))));
}